/**
 * Route for `retargeting-pixel-support`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RetargetingPixelSupportPage } from "../features/retargeting-pixel-support/RetargetingPixelSupportPage";

export const retargetingPixelSupportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/retargeting-pixel-support",
	component: RetargetingPixelSupportPage,
});

export default retargetingPixelSupportRoute;
